import Hamb from "../../../../../assets/images/png/Hamb.webp";
import ProgrammeImage1 from "../../../../../assets/images/png/courses/programme1.webp";
import ProgrammeImage2 from "../../../../../assets/images/png/courses/programme2.webp";

import SchoolImage from "../../../../../assets/images/png/school/data-school.webp";

export const dataSchoolDataAfrica = {
  tag: "Data",
  id: "dataSchool",
  url: "/data-school",
  image: SchoolImage,

  name: "Data School",
  description: `The Utiva data school is designed to help data enthusiasts kickstart their journey to 
  learning analytics and data strategy, as well as helping 
  profesionals advance in the data space. `,
  keywords: `Data science, Data science course, Data analytics, Data school, data science training, Python, PowerBI, Excel`,
  metatags: `Data science courses in Nigeria. Become a data analyst in 1 months through our learning program. Learn Python, PowerBI, Excel to prepare you for the future of work.`,
  courses: [
    {
      id: 1,
      courseImage: ProgrammeImage1,
      courseName: "Data Science Bootcamp",
      courseDescription: `
      This Program is designed for Africans in diaspora to
      master Data Science in 4 months and prepare you for jobs in Data Science.
      Tools Include: SQL, Excel, PowerBI & Python.
    `,
      courseStartDate: "December 2, 2023",

      courseDuration: "6 Months",

      courseTags: ["For Data Enthusiasts", "For Early Professionals"],

      courseUrl: "/data-science-bootcamp",

      enrolUrl: "https://flutterwave.com/pay/global-market",
    },
    {
      id: 3,
      courseImage: ProgrammeImage2,
      courseName: "Data Analytics Bootcamp",
      courseDescription: `
      The Data Analytics bootcamp of the Data School is designed 
      to help professionals learn the analytics and data strategy,
       bringing the value of Big Data Analytics to your current role.
    `,
      courseStartDate: "December 2, 2023",

      courseDuration: "3 Months",

      courseTags: ["For Professionals"],
      courseUrl: "/data-analytics-bootcamp",

      enrolUrl: "https://flutterwave.com/pay/utiva-accelerator-",
    },
  ],

  testimony: {
    testimonierImage: Hamb,
    testimonierName: "Mayowa Hambolu",
    testimonierTitle: "Data Analyst",
    testimonyDescription: `I went through the Data Analytics Bootcamp and then the ‘Big Data with Python’ program. I am now a Data analyst and Consultant.`,
  },

  article: [],
};
